<script lang="ts">
  import type { HTMLInputAttributes } from "svelte/elements";
  import { cn } from "$lib/utils/cn";

  type Props = Omit<HTMLInputAttributes, "type" | "value" | "checked"> & {
    class?: string;
    label?: string;
    checked?: boolean;
  };

  let {
    class: className,
    label,
    checked = $bindable(false),
    id,
    ...rest
  }: Props = $props();
</script>

<label class={cn("inline-flex cursor-pointer items-center gap-2 text-sm", className)} for={id}>
  <input
    {id}
    type="checkbox"
    bind:checked
    class="size-4 rounded border-(--surface-border-strong) text-(--surface-accent) focus:ring-(--surface-accent)/30"
    {...rest}
  />
  {#if label}
    <span>{label}</span>
  {/if}
</label>
